import React from 'react';
import PropTypes from 'prop-types';
import {
  withStyles,
  Paper,
  Typography,
  Icon,
  Button,
} from '@material-ui/core';
import { TenantService } from '@pingum/api-services';
import { getTenantFromUrl } from '../../../utils/urlHelper';
import styles from './styles';

const tenantUrl = TenantService.getTenantUrl(getTenantFromUrl());

export const AccessDeniedPageComponent = ({ classes }) => (
  <div className={classes.container}>
    <div className={classes.content}>
      <Paper className={classes.root} elevation={10}>
        <Icon className={classes.icon}>
          block
        </Icon>
        <Typography
          variant="h3"
          align="center"
        >
          Access Denied
        </Typography>
        <Typography variant="subtitle1" align="center" gutterBottom>
          You do not have access to the page you were trying to reach.
        </Typography>
        <Typography variant="body2" align="center" gutterBottom>
          Please make sure you have access to
          <br />
          <strong><a href={tenantUrl}>{tenantUrl}</a></strong>.
        </Typography>
        <div className={classes.buttonContainer}>
          <Button
            color="primary"
            size="small"
            href="/"
            variant="contained"
          >
            Return Home
          </Button>
        </div>
      </Paper>
    </div>
  </div>
);

AccessDeniedPageComponent.propTypes = { classes: PropTypes.object };
AccessDeniedPageComponent.defaultProps = { classes: {} };

export default withStyles(styles, { withTheme: true })(AccessDeniedPageComponent);
